import React,{useState,useEffect} from 'react'
import { Box, IconButton, Table, TableBody, Tooltip,
    TableContainer, TableHead, TableRow,    
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles'
import moment from 'moment';
import {celda} from '../Generales/TablaGeneral';
import { printConsole } from '../funciones/ConsolaLog';
import NuevoContrato from './NvoEditSeguro';
import {AddCircleOutline} from '@material-ui/icons';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import EditarContrato from './EditarContrato';
import CreateIcon from '@material-ui/icons/Create';
const useStyles = makeStyles((theme) => ({
    
        root: {
            width: '42rem',
        },
        container: {
            maxHeight: 420,
            width: '42rem',
        },
        tableRow: {
            "&$selected, &$selected:hover": {
                backgroundColor: "#F46239"
            }
        },
        tableCell: {
            "$selected &": {
                color: "white"
            }
        },
        hover: {},
        selected: {}    
  }))
    

const TablaContrato = ({datos,setContrato,Buscar}) => {
    const classes = useStyles();
    const [selectedID, setSelectedID] = useState([]);
    const [modalNvoContrato,setModalNvoContrato]= useState(false);
    const [modalEditContrato,setModalEditContrato]= useState(false);
    useEffect(() => {
        printConsole(datos)
    
    
    }, [ ])
 
    function Row(props) {
        const {row} = props;
      //  let nomPdf=row.Pdf.length!==0 ? row.Pdf.substring(row.Pdf.lastIndexOf('/')+1,row.Pdf.length):""
        return (           
        <TableRow  selected={selectedID?.Id === row.Id} 
            classes={{hover: classes.hover, selected: classes.selected}}
            className={classes.tableRow}    
            onClick={() => { 
                setSelectedID(row) 
                setContrato(row) }}                     
        >   
            {  celda("center", {width: 45+'px' },       
                <Tooltip title="Editar Contrato">
                <IconButton size="small" onClick={()=>{setModalEditContrato(true)}}   >
                    <CreateIcon style={{color :selectedID?.Id === row.Id ? "white" :""}}/>
                </IconButton>              
                </Tooltip>         
            , 1, classes.tableCell)  }                  
            {  /* celda("center", { },  
                row.Pdf.length!==0?
                <a href={row.Pdf}> ​​​​​​​​ 
                    <Tooltip title={`Descargar ${nomPdf}`}>
                    <IconButton size="small"  >
                        <PictureAsPdfIcon/>
                    </IconButton>
                    </Tooltip>
                </a>:null
                , 2, classes.tableCell)   */}            
            {/* celda("center", {width: 45+'px'}, 
                row.Id
            , 3, classes.tableCell) */}  
            {celda("center", {}, row.Poliza, 7, classes.tableCell)}
            {celda("center", {width: 45+'px', fontSize:12+'px'}, 
                row.FIni=== "1900-01-01 00:00" ? 
                "" : moment.utc( row.FIni).format('DD/MM/YYYY')
            , 4, classes.tableCell)}   
            {celda("center", {width: 45+'px', paddingLeft:".2rem", fontSize:12+'px'}, 
                row.FFin=== "1900-01-01 00:00" ? 
                "" : moment.utc( row.FFin).format('DD/MM/YYYY')
            , 5, classes.tableCell)}      
                        
            {celda("left", {paddingLeft:".4rem", fontSize:12+'px'}, row.AsegNom, 10, classes.tableCell)}
            
            {celda("center", {}, row.TpNom, 8, classes.tableCell)}
            {/* celda("left", {paddingLeft:".2rem", fontSize:12+'px'}, row.Descr, 9, classes.tableCell) */}
        </TableRow>                          
        );
    }

const tablaCompleta = () => {

    return (
    <TableContainer className={classes.container}>
    <Table stickyHeader aria-label="sticky table">
        <TableHead>
            <TableRow>
                {/* celda("center", {}, datos.length , 1, "")  */}
                {celda("left", {},  
                <span>
                    {`${datos.length } `}                
                    <Tooltip title="Agregar Contrato">
                        <IconButton onClick={()=>{setModalNvoContrato(true)}} size="small" >
                            <AddCircleOutline />
                        </IconButton>
                    </Tooltip>
                </span>
                , 2, "")}               
                {celda("center", {}, "Poliza", 7, "")}           
                {/* celda("center", {}, "Folio", 3, "") */ }     
                {celda("center", {}, "F.Inicio",4, "")}   
                {celda("center", {}, "F.Fin",5, "")}     
                {/* celda("center", {}, "F.Firma",6, "") */}     
                {celda("center", {}, "Aseguradora", 10, "")}
                
                {celda("center", {}, "Tipo", 8, "")}
                {/* celda("center", {}, "Descripción",9, "") */}
                                                                                            
            </TableRow>
        </TableHead>
        <TableBody>                                                                 
            {datos.length !== 0  ? 
                (datos.map((row) => (
                    <Row key={row.Id} row={row}/>
                ))) 
            : 
            <TableRow className={classes.tableRow} >            
                {celda("center", {}, "", 1, classes.tableCell)}
                {celda("center", {}, "", 2, classes.tableCell)}
                {celda("center", {}, "Sin", 3, classes.tableCell)}
                {celda("center", {}, "", 4, classes.tableCell)}
                {celda("center", {}, "", 5, classes.tableCell)}
                {celda("center", {}, "Registros", 6, classes.tableCell)}
                {celda("center", {}, "", 7, classes.tableCell)}
                {celda("center", {}, "", 8, classes.tableCell)}
            </TableRow>       
            }
        </TableBody>
    </Table>
    </TableContainer>
    )
    }

    const modNvoContrato= modalNvoContrato ? <NuevoContrato modalAbierto={modalNvoContrato} Buscar={Buscar}
                                                setModalAbierto={setModalNvoContrato} registro={[]} /> :null
    const modEditContrato= modalEditContrato ? <NuevoContrato modalAbierto={modalEditContrato} Buscar={Buscar}
                                                setModalAbierto={setModalEditContrato} registro={selectedID} /> :null
  /*   const modEditContrato= modalEditContrato ? <EditarContrato modalAbierto={modalEditContrato} Buscar={Buscar}
                                                setModalAbierto={setModalEditContrato} registro={selectedID} /> :null       */                                          
  return (
    <Box>
        {modNvoContrato}
        {modEditContrato}
        {tablaCompleta()}
    </Box>
  )
}

export default TablaContrato